import { RefObject, useCallback, useTransition } from 'react';
import { TextInput as TextInputType } from 'react-native';
import { useTableContext } from '@experiences/components/table/blocs/table-context';
import { useTableFocusStore } from '@experiences/components/table/blocs/stores/table-focus-store';

/**
 * Shared helper that clears focus state and blurs the input.
 *
 * The call order matters: `setActiveTableId` runs synchronously **before**
 * `blur()` so the table scope stays active through the mode transition.
 */
export const useClearFocusAndBlur = (
  inputRef: RefObject<TextInputType | null>,
) => {
  const { tableId } = useTableContext();
  const [, startTransition] = useTransition();

  return useCallback(() => {
    const store = useTableFocusStore.getState();
    startTransition(() => {
      store.setFocusedIndex(tableId, null);
      store.setFocusedColumn(tableId, null);
    });
    store.setActiveTableId(tableId);
    inputRef.current?.blur();
  }, [inputRef, startTransition, tableId]);
};
